import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTimes } from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../abstracts";
import { get } from "lodash";
import AddToolTip from "../AddToolTip";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const UploadComponent = (props) => {
  const {
    setFieldValue,
    label,
    name,
    values,
    clearUploadFile,
    setFileUploadRequired,
    setNewFile,
    clearField,
    setClearField,
    setShowFileName,
    fileExtensions,
    fieldName = "uploadSourceFile",
  } = props;
  const [myFiles, setMyFiles] = useState(get(values, fieldName, []));
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [edit, setEdit] = useState(false);

  function getBlobURL() {
    return URL.createObjectURL(myFiles[0]);
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (myFiles.length === 0) {
        setMyFiles([...myFiles, ...acceptedFiles]);
        setFieldValue(name, acceptedFiles);
        if (setNewFile) {
          setNewFile(name, acceptedFiles);
        }
      }
      if (acceptedFiles.length === 0) {
        setIsUploadSuccess(false);
      } else {
        setIsUploadSuccess(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [myFiles]
  );
  useDeepEffect(() => {
    if (clearField) {
      setMyFiles([]);
      setClearField(false);
      setShowFileName(true);
    }
  }, [clearField]);

  // useDeepEffect(() => {
  //   setEdit(true);
  //   setMyFiles([get(values, fieldName, [])]);
  // }, [values]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: fileExtensions,
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    if (setFileUploadRequired) {
      setFileUploadRequired("");
    }
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    if (clearUploadFile) {
      clearUploadFile();
    }
    if (setNewFile) {
      setNewFile([]);
      setFieldValue(name, undefined);
      setShowFileName(true);
    }
  };

  const files = myFiles.map((file) => (
    <div className="d-flex" style={{ justifyContent: "flex-start" }}>
      <span
        style={{
          textOverflow: "ellipsis",
        }}
      >
        {edit ? (
          file.fileName.length > 25 ? (
            <AddToolTip name={file.fileName}>
              <div>
                {(file.fileName || "").slice(0, 15)}...
                {(file.fileName || "").slice(
                  file.fileName.length - 16,
                  file.fileName.lastIndexOf(".")
                )}
                {(file.fileName || "").slice(
                  file.fileName.lastIndexOf("."),
                  file.fileName.length
                )}{" "}
              </div>
            </AddToolTip>
          ) : (
            <div>
              {file.fileName.slice(0, file.fileName.lastIndexOf("."))}
              {file.fileName.slice(
                file.fileName.lastIndexOf("."),
                file.fileName.length
              )}{" "}
            </div>
          )
        ) : file.path.length > 25 ? (
          <AddToolTip name={file.path}>
            <div>
              {(file.path || "").slice(0, 15)}...
              {(file.path || "").slice(
                file.path.length - 16,
                file.path.lastIndexOf(".")
              )}
              {(file.path || "").slice(
                file.path.lastIndexOf("."),
                file.path.length
              )}{" "}
            </div>
          </AddToolTip>
        ) : (
          <div>
            {file.path.slice(0, file.path.lastIndexOf("."))}
            {file.path.slice(file.path.lastIndexOf("."), file.path.length)}{" "}
          </div>
        )}
      </span>
      <span
        className="ml-4"
        style={{ cursor: "pointer" }}
        onClick={removeFile(file)}
      >
        <FontAwesomeIcon
          icon={faTimes}
          color={"#ff0000"}
          onClick={() => setFieldValue(name, undefined)}
        />
      </span>
    </div>
  ));

  const getClassName = isUploadSuccess
    ? "upload-docs border-color-normal"
    : "upload-docs border-color-red";

  return (
    <div>
      {}
      <label className="label-text-upload">{label}</label>
      <div {...getRootProps({ className: "dropzone" })}>
        <input name={name} {...getInputProps()} disabled={myFiles.length} />
        <div className={getClassName}>
          <FontAwesomeIcon icon={faUpload} />
          <p> Drag & Drop Here</p>
          <p> or</p>
          <p className="link-text"> Browse file</p>
        </div>
      </div>
      <span className="file-type-upload">
        Accepted File Type : {fileExtensions}
      </span>
      <p className="file-type-red">
        {!isUploadSuccess ? "*Please upload a valid file" : null}
      </p>
      {files}
      {/* {enablePreview && isUploadSuccess && <img src="https://storageaccountcore2ad3a.blob.core.windows.net/employeeimagecontainer/1" />
      } */}
      {/* {enablePreview && isUploadSuccess && (
        <img
          style={{ width: "75%", height: "75%" }}
          src={URL.createObjectURL(myFiles[0])}
        />
      )} */}
      {/* <object data="https://storageaccountcore2ad3a.blob.core.windows.net/inputfile/InputFile_2021-05-09-12-05-54.xlsx" type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" width="100%" height="100%">
      <p>Alternative text - include a link <a href="https://storageaccountcore2ad3a.blob.core.windows.net/inputfile/InputFile_2021-05-09-12-05-54.xlsx">to the PDF!</a></p>
  </object> */}
      {/* {enablePreview && (
        <DocViewer DocViewerRenderers={DocViewerRenderers} documents={docs} />
      )} */}
      {/* <object data={URL.createObjectURL(new Blob(myFiles[0], {type: "application/pdf"}))} type="application/pdf" width="50%" height="50%">
  </object> */}
    </div>
  );
};

export default UploadComponent;
